module.exports = __webpack_public_path__ + "img/bluetooth.fd01e7a2.png";